<template>
  <div id="app">
    <router-view>
    </router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
    components: {
    },
    mounted() {
      this.updateMetaTags();
    },
    watch: {
      '$route'() {
        this.updateMetaTags();
      }
    },
    methods: {
      updateMetaTags() {
        const route = this.$route;
        const meta = route.meta || {};
        
        // 更新页面标题
        if (meta.title) {
          document.title = meta.title;
        }
        
        // 更新或创建meta标签
        this.updateMetaTag('description', meta.description);
        this.updateMetaTag('keywords', meta.keywords);
        
        // 更新Open Graph标签
        if (meta.og) {
          this.updateMetaProperty('og:title', meta.og.title);
          this.updateMetaProperty('og:description', meta.og.description);
          this.updateMetaProperty('og:type', meta.og.type);
          this.updateMetaProperty('og:image', meta.og.image);
        }
        
        // 更新Twitter Card标签
        this.updateMetaProperty('twitter:card', 'summary_large_image');
        this.updateMetaProperty('twitter:title', meta.og?.title || meta.title);
        this.updateMetaProperty('twitter:description', meta.og?.description || meta.description);
        this.updateMetaProperty('twitter:image', meta.og?.image);
      },
      
      updateMetaTag(name, content) {
        if (!content) return;
        
        let tag = document.querySelector(`meta[name="${name}"]`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.name = name;
          document.head.appendChild(tag);
        }
        tag.content = content;
      },
      
      updateMetaProperty(property, content) {
        if (!content) return;
        
        let tag = document.querySelector(`meta[property="${property}"]`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.property = property;
          document.head.appendChild(tag);
        }
        tag.content = content;
      }
    }
  }
</script>

<style type="scss">
  #app {
    background-size: 100% 100%;
  }
  
  html, body {
    height: 100vh;
    width: 100%;
    background-color: #ECEFF5;
    margin: 0;
    padding: 0;
  }

  /* 确保导航栏在所有页面都正确显示 */
  .header {
    display: block !important;
    visibility: visible !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 9999 !important;
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px) !important;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1) !important;
    border-bottom: 1px solid rgba(0, 212, 180, 0.1) !important;
    height: 80px !important;
    padding: 0 40px !important;
    transition: all 0.3s ease !important;
  }

  .header-content {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    height: 80px !important;
    width: 100% !important;
    max-width: 1400px !important;
    margin: 0 auto !important;
  }

  .logo {
    display: block !important;
    cursor: pointer !important;
    height: 36px !important;
    width: auto !important;
    transition: transform 0.3s ease !important;
  }

  .logo-image {
    display: block !important;
    height: 55px !important;
    width: auto !important;
    transition: transform 0.3s ease !important;
  }

  .nav {
    display: flex !important;
    gap: 40px !important;
  }

  .nav-item {
    display: inline-block !important;
    color: #333 !important;
    text-decoration: none !important;
    font-size: 13px !important;
    padding: 10px 0 !important;
    border-bottom: 2px solid transparent !important;
    transition: all 0.3s ease !important;
    position: relative !important;
  }

  .nav-item:hover,
  .nav-item.active,
  .nav-item.router-link-active {
    color: #00D4B4 !important;
    border-bottom-color: #00D4B4 !important;
  }

  .language {
    display: flex !important;
    align-items: center !important;
    gap: 5px !important;
    color: #666 !important;
    font-size: 14px !important;
    cursor: pointer !important;
    transition: color 0.3s ease !important;
  }

  .language:hover {
    color: #00D4B4 !important;
  }

  /* 移动端响应式样式 */
  @media (max-width: 768px) {
    .header {
      padding: 0 20px !important;
      height: 60px !important;
    }
    
    .header-content {
      height: 60px !important;
    }
    
    .nav {
      gap: 20px !important;
    }
    
    .nav-item {
      font-size: 12px !important;
      padding: 8px 0 !important;
    }
    
    .logo-image {
      height: 40px !important;
    }
    
    .language {
      font-size: 12px !important;
    }
  }

  @media (max-width: 480px) {
    .header {
      padding: 0 15px !important;
    }
    
    .nav {
      gap: 15px !important;
    }
    
    .nav-item {
      font-size: 11px !important;
      padding: 6px 0 !important;
    }
    
    .language span:not(.dropdown-arrow) {
      display: none !important;
    }
  }
</style>